import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonAccordion, IonAccordionGroup, IonCard, IonBadge, IonItem, IonLabel, modalController } from '@ionic/vue';
import ArchivedRuleModal from "@/components/ArchivedRuleModal.vue";
import { computed } from 'vue';
import { useStore } from 'vuex';
import { translate } from '@hotwax/dxp-components';
import { RuleService } from '@/services/RuleService';
import { showToast } from '@/utils';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArchivedRuleItem',
  setup(__props) {

const store = useStore();

const archivedRules = computed(() => store.getters["rule/getArchivedRules"]);
const isReorderActive = computed(() => store.getters["rule/isReorderActive"]);
const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);

async function openArchivedRuleModal() {
  const archivedRuleModal = await modalController.create({
    component: ArchivedRuleModal,
    componentProps: {
      archivedRules: archivedRules.value
    }
  })

  archivedRuleModal.onDidDismiss().then(async (result) => {
    if(result?.data?.rulesToUnarchive?.length) {
      emitter.emit("presentLoader")
      const rulesToUnarchive = result.data.rulesToUnarchive
      
      const responses = await Promise.allSettled(rulesToUnarchive.map(async (rule: any) => {
        rule.statusId = "ATP_RULE_ACTIVE"
        await RuleService.updateRule(rule, rule.ruleId)
      }))

      const hasFailedResponses = responses.some((response: any) => response.status !== "fulfilled")
      if(hasFailedResponses) {
        showToast(translate("Failed to unarchive some rules."))
      }
      await store.dispatch("rule/fetchRules", { ruleGroupId: ruleGroup.value.ruleGroupId })
      emitter.emit("dismissLoader")
    }
  })

  archivedRuleModal.present();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordionGroup), { value: isReorderActive.value }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordion), { value: "false" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            slot: "header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.stopImmediatePropagation()))
          }),
          _createVNode(_unref(IonCard), { slot: "content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                button: "",
                lines: "full",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openArchivedRuleModal()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("Archived")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonBadge), {
                    slot: "end",
                    color: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(archivedRules.value.length) + " " + _toDisplayString(_unref(translate)(archivedRules.value.length === 1 ? "rule" : "rules")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})